import { Link as RouterLink } from 'react-router-dom';
import React from 'react';

// Import the font inside the component
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

function Footer() {
  const handleHomeClick = (e) => {
    e.preventDefault();
    const currentPath = window.location.pathname;
    if (currentPath === '/') {
      // If already on homepage, just scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Navigate to homepage
      window.location.href = '/';
    }
  };

  const handleServicesClick = (e) => {
    e.preventDefault();
    const currentPath = window.location.pathname;
    if (currentPath === '/') {
      // If on homepage, scroll to services section
      const element = document.getElementById('services');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage with services hash
      window.location.href = '/#services';
    }
  };

  const handleAboutClick = (e) => {
    e.preventDefault();
    const currentPath = window.location.pathname;
    if (currentPath === '/') {
      // If on homepage, scroll to about section
      const element = document.querySelector('.about-scroll') || document.getElementById('about-scroll');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      // Navigate to homepage with about hash
      window.location.href = '/#about-scroll';
    }
  };

  const handleBlogsClick = (e) => {
    const currentPath = window.location.pathname;
    if (currentPath === '/blogs') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleCalculatorClick = (e) => {
    const currentPath = window.location.pathname;
    if (currentPath === '/solar-calculator') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleContactClick = (e) => {
    const currentPath = window.location.pathname;
    if (currentPath === '/callback') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer style={{ fontFamily: "'Poppins', sans-serif" }} role="contentinfo">
      <div className="container">
        <div className="row">
          <div className="side1">
            <div className="row">
              <div className="col-md-3">
                <h2 className="logo">Lunar Electric - Solar Energy Solutions</h2>
                <p className="footer-text">
                  Leading solar panel installation company in India. Expert rooftop solar solutions for residential, commercial, and utility-scale projects.
                </p>
                <p className="footer-text" style={{marginTop: '1rem', fontSize: '14px'}}>
                  © 2024 Lunar Electric. All rights reserved<sup>®</sup>
                </p>
              </div>
              <div className="col-md-3">
                <p className="footer-title">Important Link</p>
                <ul>
                  <li>
                    <a href="/" onClick={handleHomeClick}>
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="#services" onClick={handleServicesClick}>
                      Services
                    </a>
                  </li>
                  <li>
                    <a href="#about-scroll" onClick={handleAboutClick}>
                      About Us
                    </a>
                  </li>
                  <li>
                    <RouterLink to="/blogs" onClick={handleBlogsClick}>
                      Blogs
                    </RouterLink>
                  </li>
                  <li>
                    <RouterLink to="/solar-calculator" onClick={handleCalculatorClick}>
                      Solar Calculator
                    </RouterLink>
                  </li>
                  <li>
                    <RouterLink to="/callback" onClick={handleContactClick}>
                      Contact
                    </RouterLink>
                  </li>
                  <li>
                    <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">
                      Sitemap
                    </a>
                  </li>
                  <li>
                    <RouterLink to="/privacy-policy">
                      Privacy Policy
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="side2">
            <div className="row">
              <div className="col-md-3">
                <p className="footer-title">Contact</p>
                <ul>
                  <li>
                    <a href="mailto:ronak@lunarelectric.in">ronak@lunarelectric.in</a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/ronakpoojara"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ronak Poojara
                    </a>
                  </li>
                  <li>
                    <a href="tel:+919148857417"> +91 9148857417</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <p className="footer-title">Social Media</p>
                <ul>
                  <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/ronakpoojara">
                      Linkedin
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="gotop">
        <i className="fas fa-level-up-alt"></i>
      </button>
    </footer>
  );
}

export default Footer;
